import React, {useState} from "react";
import axios from "axios";
import language from "./language";
import {Link} from "react-router-dom";

interface Item {
    language: string;
    title: string;
    text: string;
    id: number;
    date_string: string;
}

function Home() {

    const lang = language();
    const blogLang = 'any';
    const numberOfBlogItems = 5;
    const baseUrl = process.env.REACT_APP_API_URL + "/getPage/" + process.env.REACT_APP_SITE_NAME + "/" + lang + "/home";
    const blogUrl = process.env.REACT_APP_API_URL + "/getBlogs/" + process.env.REACT_APP_SITE_NAME + "/" + blogLang + "/" + numberOfBlogItems;

    const [title, setTitle] = useState<string>("");
    const [text, setText] = useState<string>("");
    const [list, setList] = useState<Item[]>([]);
    const [id, setId] = useState<number>(0);
    const [date, setDate] = useState<string>("");


    post(baseUrl)
    get_blog_list(blogUrl);


    function post(url: string) {
        const headers = {
            "Content-Type": "application/json",
        };

        // @ts-ignore
        axios.get(url, headers)
            .then(response => {
                        setTitle(response.data.title);
                        setText(response.data.text);
                        setId(response.data.id);
                        setDate(response.data.date_string)
                }
            )
            .catch(error => {
                console.log(url)
                console.log(error)
            });
    }

    function get_blog_list(url: string) {
        const headers = {
            "Content-Type": "application/json",
        };

        // @ts-ignore
        axios.get(url, headers)
            .then(response => {
                    setList(Array.from(response.data))
                }
            )
            .catch(error => {
                console.log(error)
            });
    }


    let blog_list: any[] = [];
    if (list !== undefined) {
        // @ts-ignore
        blog_list = list.map((item) =>
            <div key={item.id}>
                <div className='blog_list_item mt-3 ml-3 mr-3'><Link to={'/blog/' + item.id}>{item.title}</Link>
                    <div
                        className='date_string'> {(item.date_string !== undefined && item.date_string.length > 10) ? item.date_string.substring(0, 10) : ''}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="float-container">
            <div className="float-child-left">
                <div className='home-content'>
                    <h2>  {title}  </h2>
                    <div dangerouslySetInnerHTML={{__html: text}}/>
                </div>

            </div>
            <div className="float-child-right">
                <div id="sidebar-wrapper">
                    <p className="sidebar-blogs">
                        <div id='linkContainer' className='ml-0'>
                            <p className='mt-5'>&nbsp;</p>
                            <div className='mt-5'>{blog_list}</div>
                        </div>
                    </p>
                </div>
            </div>
        </div>
    )
}


export default Home
